import { render } from "./RiskEstimation.vue?vue&type=template&id=6c707498&scoped=true"
import script from "./RiskEstimation.vue?vue&type=script&lang=js"
export * from "./RiskEstimation.vue?vue&type=script&lang=js"

import "./RiskEstimation.vue?vue&type=style&index=0&id=6c707498&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c707498"]])

export default __exports__
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInnerLoading});
